<!-- primary-button component -->
<div class="primary-button" [attr.aria-label]="this.text + ' button'">
  <a
    (click)="this.submit(this.text)"
    (keydown.Space)="this.submit(this.text)"
    (keydown.enter)="this.submit(this.text)"
    tabindex="0"
    class="{{ this.selected ? 'selected' : '' }} {{this.colorCssClass}}"
  >
    <span *ngIf="!this.selected" [innerHTML]="this.text"></span>
    <span *ngIf="this.selected">
      <kendo-loader
        [type]="loader.type"
        [themeColor]="loader.themeColor"
        [size]="loader.size"
      >
      </kendo-loader>
    </span>
  </a>
</div>
